import { render, staticRenderFns } from "./BetMatchSlider.vue?vue&type=template&id=3597591d&scoped=true"
import script from "./BetMatchSlider.vue?vue&type=script&lang=js"
export * from "./BetMatchSlider.vue?vue&type=script&lang=js"
import style0 from "./BetMatchSlider.vue?vue&type=style&index=0&id=3597591d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597591d",
  null
  
)

export default component.exports